import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { NavigationService } from 'src/app/shared/services/navigation/navigation.service';

export const tokenGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const token = route.queryParamMap.get('token');
  const navigation = inject(NavigationService);

  if (token) {
    return true;
  }

  navigation.goToLogin();
  return false;
};
